import { render, staticRenderFns } from "./SetupHistory.vue?vue&type=template&id=15975495&"
import script from "./SetupHistory.vue?vue&type=script&lang=js&"
export * from "./SetupHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15975495')) {
      api.createRecord('15975495', component.options)
    } else {
      api.reload('15975495', component.options)
    }
    module.hot.accept("./SetupHistory.vue?vue&type=template&id=15975495&", function () {
      api.rerender('15975495', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/SetupHistory.vue"
export default component.exports